<template>
  <main id="app" class="app" :data-route="$route.name" :data-theme="theme" @mousemove="resetSleepTimer">
    <!-- Nav -->
    <transition :name="navTransition">
      <app-header v-show="!siteIntro && navVisible" :window="window" :siteIntro="siteIntro" :site="site" :collections="collections"></app-header>
    </transition>
    <!-- Pages -->
    <div class="app__body">
      <transition :name="pageTransition">
        <router-view 
        :window="window" 
        :mobile="isMobile" 
        :siteIntro="siteIntro"
        :site="site"
        :collections="collections" 
        @toggleNav="navVisible = !navVisible" 
        @cinemagraph-playing="endIntro"
        @changeTheme="changeTheme"></router-view>
      </transition>
    </div>
    <!-- Screensaver -->
    <transition name="longfade">
      <screensaver v-if="siteIntro || sleepMode.active" :sleepMode="sleepMode.active" :siteIntro="siteIntro" :site="site"></screensaver>
    </transition>
    <subscribe-pop-up :ready="siteReady"></subscribe-pop-up>
  </main>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Config from 'src/config'
import AppHeader from './components/Nav'
import Screensaver from './components/Screensaver'
import SubscribePopUp from './components/SubscribePopUp'
import _throttle from 'lodash/throttle'
export default {
  name: 'app',
  components: {
    AppHeader,
    Screensaver,
    SubscribePopUp
  },
  data () {
    return {
      pageTransition: 'fade',
      theme: 'light',
      navVisible: true,
      siteIntro: true,
      siteIntroDuration: 3000, // ms
      siteReady: false,
      siteIntroVideoPlaying: false,
      sleepMode: {
        enabled: process.env.NODE_ENV !== 'development',
        active: false,
        timer: process.env.NODE_ENV === 'development' ? 5000 : 40000,
        timeout: null
      },
      resizeTimeout: null,
      window: {
        height: 0,
        width: 0,
        bkpt: Config.bkpt
      }
      // content
      // site: null,
      // collections: null
    }
  },
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://www.dovedaledesignstudio.com' + this.$route.path }
      ],
      meta: [
        // {
        //   name: 'description',
        //   content: this.site ? this.site.getText('site.meta_description') : ''
        // },
        // {
        //   name: 'keywords',
        //   content: this.site ? this.site.getText('site.meta_keywords') : ''
        // },
        {
          name: 'author',
          content: 'Dovedale Design Studio'
        },

        // {
        //   property: 'og:title',
        //   content: document.title ? document.title : 'Dovedale Design Studio'
        // },
        {
          property: 'og:site_name',
          content: 'Dovedale Design Studio'
        },
        // {
        //   property: 'og:description',
        //   content: this.site ? this.site.getText('site.meta_description') : ''
        // },
        {property: 'og:type', content: 'website'},

        {
          property: 'og:url',
          content: 'https://www.dovedaledesignstudio.com' + this.$route.path
        },
        // {
        //   property: 'og:image',
        //   content: this.site ? this.site.data['site.share_image'].value.main.url : ''
        // },

        {name: 'twitter:card', content: 'summary'},
        {name: 'twitter:site', content: 'https://www.dovedaledesignstudio.com' + this.$route.path},
        // {name: 'twitter:title', content: this.site ? this.site.getText('site.tagline') : ''},
        // {name: 'twitter:title', content: document.title ? document.title : 'Dovedale Design Studio'},
        // {name: 'twitter:description', content: this.site ? this.site.getText('site.meta_description') : ''},
        // {name: 'twitter:image:src', content: this.site ? this.site.data['site.share_image'].value.main.url : ''},

        // {itemprop: 'name', content: document.title ? document.title : 'Dovedale Design Studio'},
        // {itemprop: 'description', content: this.site ? this.site.getText('site.meta_description') : ''},
        // {itemprop: 'image', content: this.site ? this.site.data['site.share_image'].value.main.url : ''},

        {
          property: 'og:type',
          content: 'business.business'
        },
        {
          property: 'business:contact_data:street_address',
          content: '465 Battersea Park Rd'
        },
        {
          property: 'business:contact_data:locality',
          content: 'London'
        },
        {
          property: 'business:contact_data:region',
          content: 'London'
        },
        {
          property: 'business:contact_data:postal_code',
          content: ' SW11 4LR'
        },
        {
          property: 'business:contact_data:country_name',
          content: 'UK'
        },
        {
          property: 'place:location:latitude',
          content: '51.4722296'
        },
        {
          property: 'place:location:longitude',
          content: '-0.1655434'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'http://schema.org',
            '@type': 'LocalBusiness',
            'name': 'Dovedale Design Studio',
            'image': this.site ? this.site.data['site.share_image'].value.main.url : '',
            'address': {
              '@type': 'PostalAddress',
              'streetAddress': '465 Battersea Park Rd',
              'addressLocality': 'London',
              'addressRegion': 'London',
              'postalCode': 'SW11 4LR',
              'addressCountry': 'UK'
            },
            'telephone': '+44 779 382 2428',
            'url': 'https://dovedaledesignstudio.com'
          }
        }
      ]
    }
  },
  computed: {
    ...mapState(['site', 'collections']),
    isMobile () {
      return this.window.width <= this.window.bkpt.mobile
    },
    navTransition () {
      return this.siteIntro ? 'longfade' : 'fadeinplace'
    }
  },
  watch: {
    '$route' (to, from) {
      this.$route.meta.firstPage = false
      // theme
      if (to.name !== 'Page') this.theme = 'light'
      // transition
      let transition = 'fade' // default
      const toDepth = to.path.split('/')
      const fromDepth = from.path.split('/')
      // slide ?
      if (fromDepth.length !== toDepth.length && to.name !== 'Page' && from.name !== 'Page') {
        transition = toDepth.length < fromDepth.length ? 'slide-right' : 'slide-left'
      }
      // scroll top after transition ?
      let isOverlay = to.matched.some(record => record.meta.isOverlay)
      if (transition !== 'slide-right' && !isOverlay && !to.hash) {
        const delay = transition.indexOf('slide') > -1 ? 700 : 400
        setTimeout(function () {
          window.scrollTo(0, 0)
        }, delay)
      }
      this.pageTransition = transition

      setTimeout(() => {
        Vue.analytics.fbq.event('PageView')
      }, 200)
    },
    site () {
      // update meta defaults
      const descrip = this.site.getText('site.meta_description')
      if (descrip) Vue.updateMeta._siteDescription = descrip
      console.log('site', this.site)
    }
  },
  methods: {
    changeTheme: function (value = 'light') {
      this.theme = value
    },
    onResize: function () {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(this.saveWindowData, 100)
    },
    saveWindowData: function () {
      this.window.height = window.innerHeight
      this.window.width = window.innerWidth
    },
    endIntro: function () {
      this.siteIntroVideoPlaying = true
      if (this.siteReady) this.siteIntro = false
    },
    siteIntroInit: function () {
      this.siteIntro = window.innerWidth > this.window.bkpt.mobile && this.$route.name === 'Intro' && this.$route.meta.firstPage
      if (!this.siteIntro) { this.siteReady = true; return }
      setTimeout(() => {
        this.siteReady = true
        if (this.siteIntroVideoPlaying) this.siteIntro = false
      }, this.siteIntroDuration)
    },
    resetSleepTimer: _throttle(function () {
      clearTimeout(this.sleepMode.timeout)
      // disable
      if (this.sleepMode.active) {
        this.sleepMode.active = false
      }
      // reset timer
      if (this.sleepMode.enabled) {
        if (!this.mobileLayout) {
          this.sleepMode.timeout = setTimeout(() => { this.sleepMode.active = true }, this.sleepMode.timer)
        }
      }
    }, 1500)
  },
  beforeCreate () {
    this.$store.dispatch('getInitialDocs')
  },
  created () {
    this.$route.meta.firstPage = true
    this.saveWindowData()
    this.siteIntroInit()
    window.addEventListener('resize', this.onResize)
    console.log('Sleep Enabled: ' + this.sleepMode.enabled)
  },
  mounted () {
    Vue.analytics.fbq.init('2293469067361860')
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss">
@import './style/variables'; // fonts, ...
@import './style/reset';
@import './style/helpers';
@import './style/typography';
@import './style/ui';
@import './style/transitions';
@import './style/sticky-headers';

html{
  font-size:$rem; // rem
}

.app {
  text-align: center;
  position:relative;
  // themeing
  color: $black;
  background-color:$white;
  border-color:$black;
  stroke: $black;
  &[data-theme="dark"]{
    color: $white;
    background-color:$black;
    border-color:$white;
    stroke: $white; 
  }

  .is-hidden-mobile{
    @media (max-width:$bkpt-mobile) {
      display:none !important;
    }
  }

  .is-hidden-tablet{
    @media (min-width:$bkpt-mobile + 1) {
      display:none !important;
    }
  }

  .icon{
    display:block;
    &:after{
      content:'';
      display: block;
      background-size:contain;
      background-position: center center;
      background-repeat:no-repeat;
    }
    &.icon--close{
      &:after{
        margin-top: 1px;
        width:(16/12)*1rem; // (29px/30px*$rem);
        height:(16/12)*1rem; // (29px/30px*$rem);
        background-image:url('./assets/Close.svg');
      }
    }
    &.icon--menu{
      &:after{
        margin-top: 1px;
        width:(16/12)*1rem; // (39px/30px*$rem);
        height:(16/12)*1rem; // (22px/30px*$rem);
        background-image:url('./assets/Menu.svg');
      }
    }
  }
  &[data-theme="dark"] .icon{
    filter:invert(100%);
  }
  .icon-asterisk{
    @include icon(asterisk);
  }
  .icon-close-overlay{
    @include icon('close-overlay');
  } 
}

.app__body{
  min-height:100vh;
}

button {
  cursor: pointer;
}

pre {
  text-align: left;
  background-color: black;
  color: lightgreen;
  padding: 1rem;
  font-size: 0.9rem;
  line-height: 1.0;
}
</style>



// WEBPACK FOOTER //
// App.vue?3503a306